import React, { useEffect, useRef } from 'react'
import lottie from 'lottie-web/build/player/lottie_light'

export const ANIMATION_SELECTOR = 'instruction-'

const LottieAnimation = ({ url, index, className }) => {
  const container = useRef(null)
  const animation = useRef(null)

  useEffect(() => {
    if (animation.current) return
    animation.current = lottie.loadAnimation({
      container: container.current,
      autoplay: true,
      name: ANIMATION_SELECTOR + index,
      path: url,
      rendererSettings: {
        viewBoxOnly: true,
        className: 'lottie-animation'
      }
    })
    return () => {
      animation.current.destroy()
    }
  }, [index, animation, url])

  return (
    <div
      ref={container}
      data-testid={`animation-${index}`}
      className={className}
    />
  )
}

export default LottieAnimation
